<template>
  <div id="statement" class="statement">
      <el-table
        v-if="!mobileMode"
        :data="statementDate"
      >
        <el-table-column
          fixed
          align="center"
          style="word-wrap:break-word"
          header-align="center"
          prop="name"
          label="ФИО"
          width="200">
        </el-table-column>
        <el-table-column
          v-for="(date, index) in dateList"
          :key="index"
          align="center"
          :label="date.date"
          width="100"
          prop="absence"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.presenceList[index].grade">{{scope.row.presenceList[index].grade}}</span>
            <span v-if="!scope.row.presenceList[index].grade">{{scope.row.presenceList[index].absence ? 'Н/Я' : ''}}</span>
          </template>
        </el-table-column>
      </el-table>

      <button v-if="mobileMode"  class="run-slider-btn" @click="showList=true">Показать посещаемость<i class="el-icon-caret-right"></i></button>
      <transition name="fade">
        <slider
          v-if="showList"
          ref="slider"
          @next="updateCurrentSlide"
          @prev="updateCurrentSlide"
          @close="showList=false"
        >
          <div class="slide__container"  v-for="(student, index) of statementDate" :key="index">
            <div class="slide" >
              <div class="table">
                  <div class="header">
                      <div class="row-header">
                          <button :class="['header__arrow-btn', {'arrow-disble': curentSlide===0}]" @click.stop="prev"><i class="el-icon-arrow-left"></i></button>
                          <p>{{student.name}}</p>
                          <button :class="['header__arrow-btn', {'arrow-disble': curentSlide===statementDate.length-1}]" @click.stop="next"><i class="el-icon-arrow-right"></i></button>
                      </div>
                  </div>
                  <div class="body">
                      <div class="row" v-for="(presence, indexPres) of student.presenceList" :key="indexPres">
                          <span>{{dateCorrector(presence.date)}}</span>
                          <span v-if="presence.grade">{{presence.grade}}</span>
                          <span v-if="!presence.grade">{{presence.absence ? 'Н/Я' : ''}}</span>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </slider>
      </transition>
  </div>
</template>

<script>

import slider from '@/components/slider'
export default {
  props:{
    groupId: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      curentSlide:0,
      showList:false,
      statementDate:[],
      dateList:[],
      widthTable: 0,
      heightTable: 0,
    }
  },

  components:{
    slider
  },

  watch: {
    groupId() {
      this.getStatementDate();
    }
  },

  computed:{
    mobileMode(){
      return this.$store.state.mobileMode
    }
  },

  async created() {
    await this.getStatementDate();
  },

  mounted() {
    let presenseContainer = document.querySelector('#presence')
    let statementContainer = document.querySelector('#statement')
    window.addEventListener('resize', ()=>{
      // this.widthTable = presenseContainer.clientWidth
    })
    window.addEventListener('resize', ()=>{
      // this.heightTable = statementContainer.clientHeight
    })

    setTimeout(() => {
      this.widthTable = presenseContainer.clientWidth;
      this.heightTable =  statementContainer.clientHeight;
      this.hightCarousel = String(this.heightTable);
    }, 1000);
  },

  methods: {
    async getStatementDate() {
      try {
        const { data: { presenceList }, status } = await this.axios.get(`/api/journal/presence/${this.$route.params.sid}/vedomost/${this.groupId}`);

        if (status === 200) {
          this.statementDate = presenceList;
          this.dateList = this.rebuilderDate(presenceList[0].presenceList);
        }
        

      } catch (error) {
        console.warn('Failed fetch [Presence/statement/getStatementDate]', error);
      }
    },
  
    updateCurrentSlide(value){
      this.curentSlide = value
    },

    prev(){
      this.$refs.slider.prev()
    },

    next(){
        this.$refs.slider.next()
    },

    dateCorrector(value){
        return this.globalFunctions.dateCorrector(value)
    }, 

    rebuilderDate(data){
      let newDate=[]
      data.forEach(el => {
        newDate.push({absence:el.absence, date:el.date.split(' ')[0].split('-').reverse().join('.')})
      });
      return newDate

    }
  },
}
</script>

<style  lang="scss">
    .statement{
      max-width: 100%;
      margin-bottom: -10px;
      scrollbar-width: 4px;
      ::-webkit-scrollbar { width: 4px; height: 4px;}
      ::-webkit-scrollbar-button {  background-color:  #409EFF; }
      ::-webkit-scrollbar-track {  background-color:  #409EFF;}
      ::-webkit-scrollbar-track-piece { background-color: #ffffff;}
      ::-webkit-scrollbar-thumb { height: 50px; background-color:  #409EFF; border-radius: 3px;}
      ::-webkit-scrollbar-corner { background-color:  #409EFF;}
      ::-webkit-resizer { background-color:  #409EFF;}
      .el-table .cell{
        word-break: normal !important;;
      }
      .run-slider-btn{
        width: max-content;
        margin: 0 auto;
        display: grid;
        grid-template-columns: 1fr 20px;
        column-gap: 10px;
        justify-items: center;
        align-items: center;
        word-wrap: break-all;
        transition-duration: 0.3s;
        transition-property: color background-color;
        border: 1px solid $placeholder-text-clr;
        padding: 10px;
        border-radius: 10px;
        color: $brand-clr-1;
        background-color: rgba($color: $brand-clr-1, $alpha: 0.05);
        &:hover{
          border-color: $brand-clr-1;
          background-color: rgba($color: $brand-clr-1, $alpha: 1);
          color: $basic-white;
        }
      }
      .table{
            display: grid;
            height: 100%;
            grid-template-rows: max-content 1fr;

        }
        .row-header{
            display: grid;
            grid-template-columns: 40px 1fr 40px;
            justify-items: center;
            background-color: $brand-clr-1;
            color: $basic-white;
            text-align: center;

        }
        .header__arrow-btn{
            font-weight: bold;
            color: $basic-white;
            i{
                font-size: 20px;
                font-weight: inherit;
            }
        }
        .arrow-disble{
            color: $primary-text-clr;
        }   
        .row{
            display: grid;
            grid-template-columns: 1fr 1fr;
            row-gap: 10px;
            border-bottom-color: $base-border-clr;
        }
        .body{
            //height: 100%;
            overflow-y: auto;
            color: $regular-text-clr;
        }
        .slider{
          z-index: 25;
        }

    }
    
</style>